import React from "react";
import { Alert, Box, Paper, Stack, Typography } from "convertupleads-theme";
import PreviewAndEditor from "../../../common/PreviewAndEditor";

const AlertVariants = () => {
  return (
    <Stack direction={"column"} spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Variants
        </Typography>

        <Typography variant="body1">
          Two additional variants are available – outlined, and filled:
        </Typography>
      </Box>
      <Paper
        elevation={0}
        sx={{
          width: "80%",
          alignSelf: "center",
        }}
      >
        <Box mb={3}>
          <Typography variant={"h6"} color={"text.primary"} mb={1}>
            Outlined
          </Typography>

          <PreviewAndEditor
            language={"js"}
            value={
              '            <Stack sx={{ width: "100%" }} spacing={2}>\n' +
              '              <Alert variant="outlined" severity="error">\n' +
              "                This is an error alert — check it out!\n" +
              "              </Alert>\n" +
              '              <Alert variant="outlined" severity="warning">\n' +
              "                This is a warning alert — check it out!\n" +
              "              </Alert>\n" +
              '              <Alert variant="outlined" severity="info">\n' +
              "                This is an info alert — check it out!\n" +
              "              </Alert>\n" +
              '              <Alert variant="outlined" severity="success">\n' +
              "                This is a success alert — check it out!\n" +
              "              </Alert>\n" +
              "            </Stack>"
            }
          >
            <Stack direction={"column"} sx={{ width: "70%" }} spacing={2}>
              <Alert variant="outlined" severity="error">
                This is an error alert — check it out!
              </Alert>
              <Alert variant="outlined" severity="warning">
                This is a warning alert — check it out!
              </Alert>
              <Alert variant="outlined" severity="info">
                This is an info alert — check it out!
              </Alert>
              <Alert variant="outlined" severity="success">
                This is a success alert — check it out!
              </Alert>
            </Stack>
          </PreviewAndEditor>
        </Box>

        <Box mb={3}>
          <Typography variant={"h6"} color={"text.primary"} mb={1}>
            Filled
          </Typography>

          <PreviewAndEditor

            language={"js"}
            value={
              '            <Stack sx={{ width: "100%" }} spacing={2}>\n' +
              '              <Alert variant="filled" severity="error">\n' +
              "                This is an error alert — check it out!\n" +
              "              </Alert>\n" +
              '              <Alert variant="filled" severity="warning">\n' +
              "                This is a warning alert — check it out!\n" +
              "              </Alert>\n" +
              '              <Alert variant="filled" severity="info">\n' +
              "                This is an info alert — check it out!\n" +
              "              </Alert>\n" +
              '              <Alert variant="filled" severity="success">\n' +
              "                This is a success alert — check it out!\n" +
              "              </Alert>\n" +
              "            </Stack>"
            }
          >
            <Stack direction={"column"} sx={{ width: "70%" }} spacing={2}>
              <Alert variant="filled" severity="error">
                This is an error alert — check it out!
              </Alert>
              <Alert variant="filled" severity="warning">
                This is a warning alert — check it out!
              </Alert>
              <Alert variant="filled" severity="info">
                This is an info alert — check it out!
              </Alert>
              <Alert variant="filled" severity="success">
                This is a success alert — check it out!
              </Alert>
            </Stack>
          </PreviewAndEditor>
        </Box>
      </Paper>
    </Stack>
  );
};

export default AlertVariants;
